import React, {Fragment} from 'react';

class AnalysysDataViewTableStationParameter extends React.Component {

  render() {
    const {
      parameters, selectedStations, onChangeSelectedStations,
      stationParameter1, stationParameter2, stationParameterExpanded, onClickExpandCollapse, func
    } = this.props;

    func.sort((a, b) => {
      if (a > b)
        return 1;
      else if (a < b)
        return -1;
      else
        return 0;
    });

    if (!stationParameter1.length) return null;

    return (<tbody>{stationParameter1.map(level1Row => {
      const caretDown = stationParameterExpanded[level1Row.id];
      const caretRight = !stationParameterExpanded[level1Row.id];

      return ([
        <tr key={`analysis-table-row-station-${level1Row.id}`}>
          <th className="caret" style={{width: '20px', marginTop: '2px'}}
              onClick={() => onClickExpandCollapse(level1Row.id)}>
            {(caretDown === true) && (
              <i className="fa fa-caret-down" aria-hidden="true"/>
            )}
            {(caretRight === true) && (
              <i className="fa fa-caret-right" aria-hidden="true"/>
            )}
          </th>
          <th style={{left: '30px', width: '200px'}}>
            <div style={{fontWeight: 'bold'}}><input type='checkbox' checked={selectedStations[level1Row.id]}
                                                     onChange={() => onChangeSelectedStations(level1Row.id)}
                                                     style={{margin: '10px'}}/>{level1Row.name}</div>
          </th>
          {func && func.length > 0 ?
            parameters.map(parameter => func.map((i) => <td key={`analysis-table-station-${parameter}-${i}-value`}>
              <div style={{
                width: '130px',
                textAlign: 'center'
              }}>{''}</div>
            </td>)).reduce((acc, val) => {
              return [...acc, ...val];
            }, []) :
            parameters.map(parameter => <td key={`analysis-table-station-${parameter}-value`}>
              <div style={{
                width: '130px',
                textAlign: 'center'
              }}>{''}</div>
            </td>)
          }
        </tr>,
        ...(stationParameterExpanded[level1Row.id] && !!stationParameter2[level1Row.id] ? Object.keys(stationParameter2[level1Row.id]).sort((a, b) => new Date(a).valueOf() < new Date(b).valueOf() ? -1 : 1).map(key => {
          let rowData = stationParameter2[level1Row.id][key];
          return (
            <tr
              key={`analysis-table-row-station-${rowData.level > 1 ? `${rowData.parent_id}-parameter-${rowData.id}-time-${rowData.time}` : rowData.id}`}>
              <th className="caret" style={{width: '20px', marginTop: '2px'}}>{}</th>
              <th style={{left: '30px', width: '200px'}}>{rowData.time}</th>
              {func && func.length > 0 ?
                parameters.map(parameter => func.map(i => <td key={`analysis-table-parameter-${parameter}-${i}-value`}>
                  <div style={{
                    width: '60px',
                    textAlign: 'center'
                  }}>{(!!rowData[i.toLowerCase()][parameter] || rowData[i.toLowerCase()][parameter] === 0) && rowData[i.toLowerCase()][parameter]}</div>
                </td>)).reduce((acc, val) => {
                  return [...acc, ...val];
                }, []) :
                parameters.map(parameter => <td key={`analysis-table-parameter-${parameter}-value`}>
                  <div style={{
                    width: '60px',
                    textAlign: 'center'
                  }}>{(!!rowData.data[parameter] || rowData.data[parameter] === 0) && rowData.data[parameter]}</div>
                </td>)
              }
            </tr>)
        }) : [])
      ])
    })}</tbody>);
  }
}

export default AnalysysDataViewTableStationParameter;


// WEBPACK FOOTER //
// ./src/components/Analysis/Data/AnalysysDataViewTableStationParameter.js